var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.167 15.5h-.834l.834-5.833H1.25c-.733 0-.275-.625-.258-.65C2.067 7.117 3.683 4.283 5.842.5h.833l-.833 5.833h2.925c.333 0 .516.159.333.55A6504.846 6504.846 0 004.167 15.5z",
    fill: "#005FFF"
  })));
};

export default SvgBolt;